import { likePlaceReview, unlikePlaceReview } from "@/api/places";
import Iconify from "@/components/ui/Iconify";
import { useAuthContext } from "@/context/auth/useAuthContext";
import { Rating } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslations } from "@/lib/static-intl";
import SmartTranslation from "@/components/ui/SmartTranslation";
const PDW_TextReviewTile = ({
  _pl,
  setPlaceTextReviews,
  fetchPlacePosts,
  fetchPlaceTextReview,
}) => {
  const apiT = useTranslations("api");
  const { user, openLoginModal } = useAuthContext();
  const [isLiked, setIsLiked] = useState(
    _pl?.placeReviewRatingLike?.some((_l) => _l?.userId === user?.userId) ||
      false
  );
  const [totalLikes, setTotalLikes] = useState(
    _pl?._count?.placeReviewRatingLike || 0
  );

  const handleReviewLikeDislike = async () => {
    try {
      if (!user?.userId) {
        openLoginModal();
        return;
      }
      const _isLiked = isLiked;
      setIsLiked(!_isLiked);
      setTotalLikes((_t) => (_isLiked ? _t - 1 : _t + 1));
      if (_isLiked) {
        await unlikePlaceReview({
          placeReviewId: _pl?.id || _pl?._id,
          userId: user?.userId,
        });
        setPlaceTextReviews((prev) =>
          prev?.map((p) => {
            if (p?.id === _pl?.id || p?._id === _pl?._id) {
              return {
                ...p,
                _count: {
                  ...p?._count,
                  placeReviewRatingLike: p?._count?.placeReviewRatingLike - 1,
                },
              };
            }
            return p;
          })
        );
        fetchPlacePosts();
        fetchPlaceTextReview();
      } else {
        await likePlaceReview({
          placeReviewId: _pl?.id || _pl?._id,
          userId: user?.userId,
        });
        setPlaceTextReviews((prev) =>
          prev?.map((p) => {
            if (p?.id === _pl?.id || p?._id === _pl?._id) {
              return {
                ...p,
                _count: {
                  ...p?._count,
                  placeReviewRatingLike: p?._count?.placeReviewRatingLike + 1,
                },
              };
            }
            return p;
          })
        );
        fetchPlacePosts();
        fetchPlaceTextReview();
      }
    } catch (error) {
      enqueueSnackbar(
        error?.data?.response?.message ||
          error?.message ||
          apiT("error message"),
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    setIsLiked(
      _pl?.placeReviewRatingLike?.some((_l) => _l?.userId === user?.userId) ||
        false
    );
    setTotalLikes(_pl?._count?.placeReviewRatingLike || 0);
  }, [_pl, user]);
  return (
    <div className={`w-full flex flex-col gap-2 py-4`}>
      <div className="w-full flex items-center gap-2">
        {/* <PostAvatar className={"!h-8 !min-w-8"} src={null} /> */}
        <span className="font-semibold">{_pl?.username}</span>
      </div>
      <div className="w-full flex flex-col">
        <SmartTranslation
          isDynamic
          text={_pl?.review}
          as="pre"
          className="font-sans text-wrap break-words tracking-tight leading-snug text-black dark:text-white text-sm"
        />
      </div>
      <div className="w-full flex flex-col gap-1">
        <div className="w-full flex justify-between items-center gap-2">
          {isLiked ? (
            <button
              type="button"
              onClick={handleReviewLikeDislike}
              className="flex items-center justify-center gap-1"
            >
              <Iconify icon={"mdi:like"} className={"!text-red"} />
              <span className="text-xs">{totalLikes > 0 ? totalLikes : 0}</span>
            </button>
          ) : (
            <button
              type="button"
              onClick={handleReviewLikeDislike}
              className="flex items-center justify-center gap-1"
            >
              <Iconify icon={"mdi:like-outline"} className={"!opacity-60"} />
              <span className="text-xs">{totalLikes > 0 ? totalLikes : 0}</span>
            </button>
          )}
          <span className="text-black/40 dark:text-white/60 text-xs">
            {_pl?.createdAt?.split("T")[0]}
          </span>
        </div>
        {!!_pl?.rating && !isNaN(Number(_pl?.rating)) && (
          <Rating
            name="read-only"
            value={Number(_pl?.rating)}
            readOnly
            size="small"
          />
        )}
      </div>
    </div>
  );
};

export default PDW_TextReviewTile;
